import React from 'react';
import { styled } from '@ff/ui';
import Box from '@ff/ui/Box';
import { colors, H1, H3, P12, P14, P16 } from 'client/v3/typography';
import Currency from 'client/v3/components/Currency';
import PriceSummary from 'client/v3/components/PriceSummary';

export default function SummaryDetail({ summary }) {
  const {
    basePrice,
    vehicleOptions,
    subtotal,
    preorderPaidAmount,
    preorderBalance,
    preorderDepositAmount,
    dueAmount,
    vehicleModel
  } = summary || {};

  const options = vehicleOptions?.map(op => ({
    categoryName: op.vehicleOptionType.categoryName,
    code: op.vehicleOptionType.typeCode,
    name: op.vehicleOptionType.typeName,
    price: op.price,
  })) || [];

  const priceSummaryProps = {
    modelCode: vehicleModel?.fullModelCode,
    basePrice,
    options: [
      {
        ...options.find(x => x.categoryName === 'Exterior'),
      },
      {
        ...options.find(x => x.categoryName === 'Wheel'),
        categoryName: 'Wheels',
      },
      {
        ...options.find(x => x.categoryName === 'Interior'),
      },
    ],
  }

  return (
    <>
      <H1 textAlign='center'>{vehicleModel?.name}</H1>
      <Row my='30px'>
        <H3>Your Summary:</H3>
      </Row>
      <Box mb='20px'>
        <PriceSummary {...priceSummaryProps}></PriceSummary>
      </Box>
      <Divider />
      <Row my='15px'>
        <P16>Vehicle Price</P16>
        <P16><Currency>{subtotal}</Currency></P16>
      </Row>
      <Row my='15px'>
        <P12 color={colors.content1 as any}>Excludes sales tax, delivery fee, registration fee, DMV fee, etc.</P12>
      </Row>
      <Row mt='58px' mb='32px'>
        <P14>Deposit amount</P14>
        <P16><Currency>{preorderDepositAmount}</Currency></P16>
      </Row>
      {preorderPaidAmount > 0 &&
        <Row my='32px'>
          <P16>Paid amount</P16>
          <P16>-<Currency>{preorderPaidAmount}</Currency></P16>
        </Row>
      }
      {preorderBalance > 0 &&
        <Row my='32px'>
          <P16>Credit</P16>
          <P16><Currency>{preorderBalance}</Currency></P16>
        </Row>
      }
      <Divider2 />
      <Row mt='32px' mb='16px'>
        <P16 fontWeight={450}>Due Today</P16>
        <P16 fontWeight={450}><Currency>{dueAmount}</Currency></P16>
      </Row>
      <P12 mb='139px' color={colors.content1 as any} >Full refund is available before order confirmation</P12>
    </>
  );
}

const Divider = styled(Box)({
  borderTop: colors.border2,
});

const Divider2 = styled(Box)({
  borderTop: colors.border3,
});

const Row = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between'
});
